export const BILLING_WARNINGS = 'billing_warnings'
export const INTEGRATION_REPORTS = 'integration_reports'
export const ACCOUNT_REPORTS = 'account_reports'
export const ALOAI_REPORTS = 'aloai_reports'
export const IMPORT_EXPORT_REPORTS = 'import_export_reports'
export const WEBHOOK_FAILURE_NOTIFICATIONS = 'webhook_failure_notifications'